import React, { Component } from "react";
import firebase from "./Firebase.js";
import { withRouter } from "react-router";
const axios = require("axios");

class HandleLink extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      name: "",
      pwd: "",
      signedIn: false,
      text: "",
      slackID: ""
    };
  }

  componentDidMount = () => {
    const { location } = this.props;

    const inputs = this.remove_character(
      "/handle-link/",
      location.pathname
    );
    const text = inputs.substr(14, inputs.length);
    var textCleaned = text.replace(/-/g, " ");
    this.launchAppIfInstalled(textCleaned)
  };

  launchAppIfInstalled(url) {
    var app = {
      launchApp: function() {
        window.location.replace(url);
        this.timer = setTimeout(this.openWebApp, 1000);
      },
  
      openWebApp: function() {
        window.location.replace("https://apps.apple.com/us/app/kinderus/id1479425814");
      }
    };
  
    app.launchApp();
  };


  remove_character(str_to_remove, str) {
    let reg = new RegExp(str_to_remove);
    return str.replace(reg, "");
  }

  render() {
    const {content} = this.state;
    console.log(`Window width: ${this.props.width}`);

    return (
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "100%",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "10%"
        }}
      >

        redirecting...
      </div>
    );
  }
}

export default withRouter(HandleLink);
